import {AppHelper} from "../../appHelper";
import {AppBaseProps, CommonApp, Entity} from "../../core/components/commonApp";
import {GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {Grid} from "../../core/components/grid";
import {WorkPackageEntity} from "../workPackage/workPackage";
import {Helper} from "../../core/util/helper";
import {General} from "../../../siteManagement/general";
import {Config} from "../../core/config/config";
import { error } from "toastr";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export interface TriggeringErrorsGridProps {
    gridOptions:{}
    translations: StringKeyDictionary<string>;
    entity: TriggeringErrorListEntity;
    // doUpdate: (value: WorkPackageEntity[]) => void
    // doSave: ()=>Promise<boolean>
}

// noinspection JSUnusedGlobalSymbols
export default class TriggeringErrorListApp extends React.Component<TriggeringErrorListAppProps, TriggeringErrorListAppState> {
    common = new AppHelper();
    translations: { };
    triggeringErrorsGridOptions: {};
    
    constructor(props) {
        super(props);
        this.common.init(this);
    }
   
    componentDidMount() {
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), {
            apphelper: this.common,
            // handleFieldChange: this.handleFieldChange,
            // handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel
        });
        return (<CommonApp {...props}/>);
    }

    createErrorsGrid = () => {
        const props:TriggeringErrorsGridProps ={
            entity: this.props.entity,
            gridOptions: this.triggeringErrorsGridOptions,
            // lockControl: this.props.context.lockControl,
            translations: this.translations,
            // doUpdate: (packages)=> {
            //     this.reloadWorkPackages(packages);
            //     this.common.handleFieldChange({model: "entity.WorkPackages"}, packages);
            //     //this.internalSave();
            // },
            // doSave: this.onSave
        }
        return (<>
            <TriggeringErrorsGrid {...props}/>
        </>)
    }

    resetAllErrors = async () => {
        let success = await this.props.doResetAll();
        if (success)
            General.Sheet.Manager.getTopMostVisibleSheet().hide();
    }
}

export class TriggeringErrorsGrid extends React.Component<TriggeringErrorsGridProps, TriggeringErrorsGridState>{
    private translations = {};
    private gridOptions = {};
    
    constructor(props) {
        super(props);
        let options = JSON.parse(JSON.stringify(this.props.gridOptions));
        let column = options.columns.find(c => c.field == "ErrorMessage");
        if (column){
            column.template = (triggeringError: TriggeringErrorEntity) => { 
                let errorText = triggeringError.ErrorMessage;
                let suffix = " " + (Helper.getTranslation("WebCRM.Tasks.Errors.SuffixTaskOnly") || "({TaskLink})");
                if (triggeringError.Execution != null)
                {
                    suffix = " " + (Helper.getTranslation("WebCRM.Tasks.Errors.SuffixTaskWithExecution") || "({TaskLink}, #{ExecutionNo} execution)");
                }
                let translation = Helper.getTranslation["WebCRM.Tasks.Errors.Long." + triggeringError.ErrorCode];
                if (translation != null)
                    errorText = translation
                else switch (triggeringError.ErrorCode){
                    case "TTEU01":
                        errorText = errorText + ": <br/>\r\n" + triggeringError.ErrorMessage;
                        break;
                    case "TTEU03":
                        errorText = errorText + "<br/>"+triggeringError.ErrorMessage;
                        break;
                }
                
                errorText = this.processPlaceholders(triggeringError.ErrorCode + ": " + errorText + suffix, triggeringError.Context);
                
                return errorText;
            }
        }
        this.gridOptions = options;
        this.translations = this.props.translations;
    }
    
    private processPlaceholders(errorText: string, context: string): string
    {
        let contextObj = JSON.parse(context);
        
        let linksExtended = errorText.replace(/\{([^}]+)Link\}/g, (substring, p1) => {
            if (p1 == "Task")
                return `<a href="${Config.baseUrl}RecurringTask/Edit?id={TaskId}" target="_blank">{TaskNo}</a>`;
            else if (p1 == "WorkPackage")
                return `<a href="${Config.baseUrl}WorkPackage/Edit?id={WorkPackageId}" target="_blank">{WorkPackageTitle}</a>`;
            else if (p1 == "Machine")
                return `<a href="${Config.baseUrl}Machine/Edit?id={MaschNr}" target="_blank">{MaschNr}</a>`;
            else if (p1 == "Template")
                return `<a href="${Config.baseUrl}CRTemplate/Edit?id={TemplateId}" target="_blank">{TemplateTitle}</a>`;
            else if (p1 == "Part")
                return `<a href="${Config.baseUrl}Parts/Edit?id={ArtNr}" target="_blank">{PartId}</a>`;
            return substring;
        });
        
        errorText = linksExtended.replace(/\{([^}]+)\}/g, (substring, p1) => {
            if (p1 in contextObj)
                return contextObj[p1];
            return substring;
        })
        return errorText;
    }

    private handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            // await this.createNewPackage();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            // await this.edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            // await this.deletePos(dataItem.Id);
        }
    }

    private handleCustomButtonClick =  async (id: string, dataItem: WorkPackageEntity) => {
        // if (id === this.copyId) {
        // }
    }

    private selectionChange = (dataItem: TriggeringErrorEntity) => {
        if (Helper.hasValue(dataItem)) {
        }
    }

    render() {

        const standardButtons: Array<ToolBarStandardButton> = [];
        const customButtons: Array<GridCustomToolBarButton> = [];


        const content = (<div> <Grid data={this.props.entity.Errors} options={this.gridOptions} id="triggeringErrorsGrid"
                                                                 standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.selectionChange}
                                                                 customButtons={customButtons} onClickCustomButton={this.handleCustomButtonClick} /></div>);

        return (content);
    }
}

interface TriggeringErrorsGridState{
    
}

export interface TriggeringErrorListAppProps extends AppBaseProps {
    entity: TriggeringErrorListEntity;
    doResetAll: () => Promise<boolean>;
}

export interface TriggeringErrorListEntity extends Entity
{
    Errors: TriggeringErrorEntity[];
}

export interface TriggeringErrorEntity
{
    ErrorCode: string;
    ErrorMessage: string;
    Context: string;
    Execution: {}
}

interface TriggeringErrorListAppState {
}